import {
    Component, Emit, Mixins, Watch,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import {
    YPanel, YEmpty, YModal,
} from '@components/index';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

interface removeConfirm extends Vue {
    open(): void;
    close(): void;
}

@Component({
    components: {
        YPanel,
        YEmpty,
        YModal,
    },
})

/**
 * @name ProfileAddresses
 */
export default class ProfileAddresses extends Mixins(CoreMixin, HybridMixin, Props) {
    list: Array<{[k: string]: any}> = null;
    divisionConfig: object = {};
    removeAddressId: string = null;
    selectedAddress: {[k: string]: any} = null;

    /**
     * Refs types
     */
    $refs!: {
        removeConfirm: removeConfirm;
    }

    /**
     * Emit selected address
     *
     * @returns {object}
     */
    @Watch('selectedAddress')
    @Emit('selectedAddress')
    onSelectedAddressChange(): object {
        return this.selectedAddress;
    }

    /**
     * @inheritdoc
     */
    created() {
        this.fetchAddresses();
        this.fetchDivisionConfig();
    }

    /**
     * Fetch user addresses
     *
     * @returns {*}
     */
    fetchAddresses(): any {
        this.$wait.start('fetch-addresses');
        return this.$services[this.fetchAddressesService.name][this.fetchAddressesService.api]({
            id: this.$store.getters['auth/id'],
        }).then((response) => {
            this.list = response.data.results;
            if (!response.data.results.length) {
                this.$emit('emptyAddressList');
            }
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-addresses');
        });
    }

    /**
     * Fetch Division Config
     * 
     * @returns {*}
     */
    fetchDivisionConfig(): any {
        this.$wait.start('fetch-division-config');
        return this.$services[this.divisionFetchConfigService.name][this.divisionFetchConfigService.api]().then((response) => {
            this.divisionConfig = response.data.metadata.settings;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-division-config');
        });
    }

    /**
     * Remove user address
     *
     * @returns {Promise}
     */
    removeAddress() {
        this.$wait.start('loading-remove-address');
        return this.$services.Person.addressMassDelete({ ids: [this.removeAddressId] })
            .then(() => {
                this.$refs.removeConfirm.close();
                this.removeAddressId = null;
                this.fetchAddresses();
            })
            .catch((error: object) => {
                this.handleError(error);
            })
            .finally(() => {
                this.$wait.end('loading-remove-address');
            });
    }
}
